import { utils, LitElement, html, broadcastReceiver } from '@hh/global.js'
const { serializeForm, addToCart, reRenderShopifySections, renderUpsellFromFetch, fetchRecommendations } = utils

const MiniCart = customElements.get('hh-mini-cart');

class ExtendedMiniCart extends MiniCart {
  constructor() {
    console.log('ExtendedMiniCart constructor');
    super();
    this.addEventListener('removeBundleItems', this.removeBundleItems);
  }

  async removeBundleItems(event) {
    const detail = event.detail;
    const keys = detail.key.split(',');
    event?.detail?.event?.preventDefault();

    const updates = {};
    for (const key of keys) {
      if (key) {
        updates[key] = 0;
      }
    }

    this.loading = true;

    const response = await fetch(`${window.routes.cart_update_url}.js?sections=mini-cart,header`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates,
      }),
    });

    const json = await response.json();

    // Re-render key sections
    reRenderShopifySections(json);

    // Handle empty cart state
    this.querySelector(".mini-cart__empty")
      ? this.setAttribute("empty", true)
      : this.removeAttribute("empty");

    this.loading = false;
  }
}

customElements.define('extended-mini-cart', ExtendedMiniCart);
